import { render, staticRenderFns } from "./config-sync-modal.vue?vue&type=template&id=c984daf6&"
import script from "./config-sync-modal.vue?vue&type=script&lang=js&"
export * from "./config-sync-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports